<script setup>
import SvgIcon from "@/components/common/svgButton.vue";
import { t } from "@/controllerLK/GlobusLocalization"; 
</script>

<template>
  <div
    class="new-project"
  >
    <div class="new-project__title">
      <SvgIcon
        width="42px"
        height="42px"
        :name="'plus'"
      />
    </div>
    <div
      class="new-project__title"
    >
      {{ t('lk_project_card_new.title') }}
    </div>
  </div>
</template>

<style scoped lang="scss">

.new-project {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 130px;
  cursor: pointer;
  color: #FFFFFF;
  border-radius: 8px;
  background: $blue;
  min-width: 256px;

  &__title {
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
